import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { IVisitReviewForm, IVisitReviewTokenCheckInfo } from '@app/visit-reviews/models';
import { VisitReviewsService } from '@app/visit-reviews/services';
import { AnalyticsService } from '@app/shared/services/analytics/analytics.service';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { getSalonRoute } from '@app/shared/utils';

@Component({
  selector: 'app-visit-review-add',
  templateUrl: './visit-review-add.component.html',
  styleUrls: ['./visit-review-add.component.scss']
})
export class VisitReviewAddComponent implements OnInit {
  visitReviewFormData: IVisitReviewForm;
  formSubmitted: boolean;
  isTokenValid: boolean;
  salonDetails: ISalonDetailsApi;

  private tokenCheckInfo: IVisitReviewTokenCheckInfo;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private analyticsService: AnalyticsService,
    private visitReviewsService: VisitReviewsService,
    private seoService: SEOService) {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'VISIT-REVIEWS.ADD.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'VISIT-REVIEWS.ADD.META-DESCRIPTION'
      }
    ]);
  }

  ngOnInit(): void {
    const viewData: [IVisitReviewTokenCheckInfo, ISalonDetailsApi] = this.route.snapshot.data.viewData;
    const [tokenCheckInfo, salonDetails] = viewData;
    this.tokenCheckInfo = tokenCheckInfo;
    this.salonDetails = salonDetails;
    this.isTokenValid = this.tokenCheckInfo.isTokenValid;
    if (this.isTokenValid) { this.resetVisitReviewFormData(); }
    if (!this.isTokenValid) {
      this.analyticsService.sendCustomPageView(`${this.router.url}/token-expired`);
    }
  }

  ratingFormSubmitted(): void {
    this.visitReviewsService.addReview(this.visitReviewFormData)
      .subscribe(() => {
        this.formSubmitted = true;
        this.analyticsService.sendCustomPageView(`${this.router.url}/review-sent`);
      });
  }

  goToSalonPage(): void {
    this.router.navigate(getSalonRoute(this.salonDetails));
  }

  goToHomepage(): void {
    this.router.navigate(['/']);
  }

  private resetVisitReviewFormData(): void {
    this.visitReviewFormData = {
      visitId: this.tokenCheckInfo.visitId,
      token: this.route.snapshot.paramMap.get('addReviewToken'),
      allowsShowingCustomerName: true,
      description: '',
      employeesRating: 0,
      salonRating: 0,
      treatmentRating: 0
    };
  }

}
